"use client"

import { ArrowLeft } from "@/lib/icons"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import { useTranslations } from "next-intl"

interface NavigationBarProps {
  sourceName: string
  albumTitle: string
  categoryName?: string // Optional category context (e.g., "Featured", "Top Rated")
  onBack: () => void
  className?: string
}

export function NavigationBar({ sourceName, albumTitle, categoryName, onBack, className }: NavigationBarProps) {
  const t = useTranslations("navigationBar")
  return (
    <div className={cn("sticky top-0 z-10 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-b", className)}>
      <div className="flex items-center gap-3 px-4 py-3">
        <Button
          variant="ghost"
          size="sm"
          onClick={onBack}
          className="h-9 w-9 p-0"
          aria-label={t("goBack")}
        >
          <ArrowLeft className="h-5 w-5" />
        </Button>
        
        <nav aria-label={t("breadcrumb")} className="flex items-center gap-2 text-sm overflow-hidden">
          <span className="text-muted-foreground truncate">{sourceName}</span>
          {categoryName && (
            <>
              <span className="text-muted-foreground">/</span>
              <span className="text-muted-foreground truncate">{categoryName}</span>
            </>
          )}
          <span className="text-muted-foreground">/</span>
          <span className="font-medium truncate">{albumTitle}</span>
        </nav>
      </div>
    </div>
  )
}
